import React from 'react';
import { FaMap, FaCity, FaMountain, FaRoad } from 'react-icons/fa';
import { BiBuildingHouse } from 'react-icons/bi';
import { GiRiver } from 'react-icons/gi';
import { ImAirplane } from 'react-icons/im';
import { BsLayoutSplit } from 'react-icons/bs';
import Card from '~/Components/Card';
import { Content, Header, CardsContainer } from './styles';
import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function LegislacaoUrbanistica() {
	return (
		<>
			<Content>
				<Header>LEGISLAÇÃO URBANÍSTICA</Header>
				<p>Links úteis</p>
				<CardsContainer>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1BT5pWF4SpV8OKcks9XQ7v0_yPrgGa2kN"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/plano_diretor/"
						target="_blank"
						icon={
							<BiBuildingHouse size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>
									Plano Diretor e Áreas Especiais Localizadas
								</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1OjNdTnYp1KK0vkWpuMzdtdmOc1gVNGw1"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/perimetro_urbano/"
						target="_blank"
						icon={<FaMap size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Perímetro Urbano</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1hOaqH7MIPfgrghaUmhk50c9i-ohsBchI"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/parcelamento_solo/"
						target="_blank"
						icon={
							<BsLayoutSplit size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Parcelamento do Solo</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1P6UBU6lw97amOfmBZbA2zVIqszjMVSLy"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/ocupacao_solo/"
						target="_blank"
						icon={<FaCity size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Uso e Ocupação do Solo</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/13DH_NweL7qiMuAhPMYfomAudc-R_cyJ3"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/codigo_obras/"
						target="_blank"
						icon={
							<BiBuildingHouse size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Código de Obras</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1fmxx0lTFmI5DK-Hh4d7uxvQnkkKTeZUJ"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/area_inundavel/"
						target="_blank"
						icon={<GiRiver size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>ÁREA INUNDÁVEL DO RIO ITAPECERICA</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1JiHC7Epc5ui45Q3HJmJlFQb8Sgwgpma9"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/mata_noe/"
						target="_blank"
						icon={<FaMountain size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>ARIE - Mata do Noé</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1ft0Ym57fuJsE81BeFUnnPse5g_0tjT0t"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/estradas_municipais/"
						target="_blank"
						icon={<FaRoad size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Estradas Municipais</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1jcM-0ST8SwwQCTZAmlZjixJEK0Kx_kch"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/plano_mobilidade/"
						target="_blank"
						icon={<FaRoad size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Plano de Mobilidade</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						// href="https://drive.google.com/drive/folders/1bf9rMGNCu-Pz9oxS9fna0fQob27Mi6I-"
						href="http://www.prefeituradivinopolis.com.br/geoplantas/legislacao_urbanistica/zona_ruido/"
						target="_blank"
						icon={<ImAirplane size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>
									Zona de Ruído e Proteção do Aeroporto
									Brigadeiro Cabral
								</span>
							</span>
						}
					/>
				</CardsContainer>
			</Content>
			<Footer />
		</>
	);
}

export default LegislacaoUrbanistica;
